import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {Subject} from 'rxjs';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {takeUntil} from 'rxjs/operators';
import {PlatformCommandResponse} from '@shared/commands/command-base';
import {ValueMappingContainer} from '@features/data-mapping/models/data-mapping.model';
import {Router} from '@angular/router';

@Component({
    standalone: false,
    selector: 'app-platform-tool-data-mapping-folder-view',
  templateUrl: './platform-tool-data-mapping-folder-view.component.html',
  styleUrls: ['./platform-tool-data-mapping-folder-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlatformToolDataMappingFolderViewComponent implements OnInit, IPlatformToolComponent, OnDestroy  {

  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  valueMappingContainers: ValueMappingContainer[] = [];
  private unsubscribe$ = new Subject<void>();
  constructor(private platformQueryService: PlatformQueryService,
              private router: Router) { }

  ngOnInit(): void {
    const fieldMappingContainer = new ValueMappingContainer();
    const valueMappingContainer = new ValueMappingContainer();
    const growthAssumptionContainer = new ValueMappingContainer();
    const trialBalanceMappingContainer = new ValueMappingContainer();
    const dataExtractorContainer = new ValueMappingContainer();
    fieldMappingContainer.type = 'folder';
    growthAssumptionContainer.type = 'folder';
    valueMappingContainer.type = 'folder';
    trialBalanceMappingContainer.type = 'folder';
    fieldMappingContainer.fieldValues = {
      'Url': 'data-mapping/field-mapping',
      'Name' : 'Field Mappings'
    };
    valueMappingContainer.fieldValues = {
      'Url': 'data-mapping/value-mapping',
      'Name' : 'Value Mappings'
    };
    growthAssumptionContainer.fieldValues = {
      'Url': 'data-mapping/growth-assumptions',
      'Name' : 'Growth Assumptions'
    };
    trialBalanceMappingContainer.fieldValues = {
      'Url': 'data-mapping/trial-balance-mappings',
      'Name' : 'Source File Mappings'
    };
    dataExtractorContainer.fieldValues = {
      'Url': 'data-mapping/data-extractors',
      'Name' : 'Data Extractors'
    };

    this.valueMappingContainers.push(fieldMappingContainer, growthAssumptionContainer, valueMappingContainer, trialBalanceMappingContainer, dataExtractorContainer);
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onClickBucket(bucket: ValueMappingContainer) {
    this.router.navigateByUrl(bucket.fieldValues['Url']).then();
  }

}
